import merge from 'lodash-es/merge';
import useDefaultChartOptions from '@/components/charts/useDefaultChartOptions';
import { roundIfNecessary } from '@/util/helpers/numbers';
import useColumnChartOptions from '@/components/charts/useColumnChartOptions';
import { AllFilterSelectors, CourseStatistics, Region } from '@/types';

export const getRegionsColumnConfig = (regions: Region[] | null, selectedRegions: Region[], courseStatistics: CourseStatistics[]) => {
    const regionColumnChartData =
        regions
            ?.filter((currentRegion) => {
                return (
                    currentRegion.id !== AllFilterSelectors.AllRegions &&
                    currentRegion.excludeFromSorting !== true &&
                    (!selectedRegions.length || Boolean(selectedRegions.find((currentSelectedRegion) => currentSelectedRegion.id === currentRegion.id)))
                );
            })
            ?.map((currentRegion) => {
                const statisticsEventsForRegion = courseStatistics.filter((currentStatistics) => currentStatistics.region === currentRegion.id);
                const distribution = statisticsEventsForRegion.reduce(
                    (accum, current) => {
                        if (current.ended) {
                            accum.finishedStatistics++;
                        } else {
                            accum.unfinishedStatistics++;
                        }
                        return accum;
                    },
                    {
                        finishedStatistics: 0,
                        unfinishedStatistics: 0,
                    }
                );
                return { ...distribution, name: currentRegion.title, finishedPercentage: (distribution.finishedStatistics / statisticsEventsForRegion.length) * 100 || 0 };
            })
            .filter((currentRegionDistribution) => {
                return currentRegionDistribution.finishedStatistics + currentRegionDistribution.unfinishedStatistics > 0;
            })
            .sort((a, b) => {
                let result = b.finishedPercentage - a.finishedPercentage;
                if (result === 0) {
                    result = b.unfinishedStatistics + b.finishedStatistics - (a.unfinishedStatistics + a.finishedStatistics);
                }
                return result;
            }) || [];

    return {
        printTitle: 'Kommunefordeling (påbegyndte og afsluttede forløb)',
        options: merge(useDefaultChartOptions(), useColumnChartOptions(), {
            title: { text: 'Kommunefordeling' },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                    },
                },
            },
            tooltip: {
                formatter() {
                    return `<span style="font-size:10px">${(this as any).points[0].key}<br/><span style="color:${(this as any).points[0].color}">●</span> ${(this as any).points[0].series.name}: <b>${
                        (this as any).points[0].y
                    }</b><br/><span style="color:${(this as any).points[1].color}">●</span> ${(this as any).points[1].series.name}: <b>${
                        (this as any).points[1].y
                    }</b><br/><span style="color: #bcfca1">●</span> Procentuelt afsluttet: <b>${roundIfNecessary(
                        (this as any).points[1].percentage,
                        1
                    )} %</b><br/><span style="color: #eba668">●</span> Rangering: <b>${(this as any).points[0].point.index + 1}</b><br/>`;
                },
                shared: true,
            },
            legend: {
                enabled: false,
            },
            xAxis: {
                categories: regionColumnChartData.map((currentRegionData) => currentRegionData.name),
            },
            yAxis: {
                title: {
                    text: 'Antal forløb',
                },
            },
            series: [
                {
                    name: 'Ikke afsluttet',
                    data: regionColumnChartData.map((currentRegionData) => currentRegionData.unfinishedStatistics),
                },
                {
                    name: 'Afsluttet',
                    data: regionColumnChartData.map((currentRegionData) => currentRegionData.finishedStatistics),
                },
            ],
        }),
    };
};
